var map = {
	"./balkan.jpg": "d4fd",
	"./grami.jpg": "bde9",
	"./hilton.jpg": "516a",
	"./holidayinn.jpg": "b0dd",
	"./novotel.png": "0616",
	"./sense.jpg": "9ba7",
	"./vitosha-park-hotel.jpg": "5105"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcff";